import { render, staticRenderFns } from "./addOtherCompSubContract.vue?vue&type=template&id=ce9d2532"
import script from "./addOtherCompSubContract.vue?vue&type=script&lang=js"
export * from "./addOtherCompSubContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports